window.Reedsy = window.Reedsy || {};
Reedsy.Discovery = Reedsy.Discovery || {};

const CLASSES = {
  active: 'active',
  tab: 'tab',
  tabSwitcher: 'tab-switcher',
};

const OFFSET_TOP = 150;

function activateTabInContainer(containerEl, tabNumber) {
  const targetTabEl = containerEl.querySelector(`.${ CLASSES.tab }[data-tab="${ tabNumber }"]`);
  if (!targetTabEl) {
    return;
  }

  targetTabEl.classList.add(CLASSES.active);
}

function activateTrigger(triggerEl) {
  if (!triggerEl) {
    return;
  }

  triggerEl.classList.add(CLASSES.active);
}

function deactivateAllTabsForContainer(containerEl) {
  const activeTabs = containerEl.querySelectorAll(`.${ CLASSES.tab }.${ CLASSES.active }`);
  [].forEach.call(activeTabs, (tab) => {
    tab.classList.remove(CLASSES.active);
  });
}

function deactivateTriggers(tabReference) {
  const activeTriggers = document.querySelectorAll(`.${ CLASSES.tabSwitcher }.${ CLASSES.active }[data-tab-reference="${ tabReference }"]`);
  [].forEach.call(activeTriggers, (trigger) => {
    trigger.classList.remove(CLASSES.active);
  });
}

function updateHash(hash) {
  history.replaceState({}, '', hash);
}

class TabsHandler {
  static switch(triggerEl, tabNumber, shouldScroll = false, shouldUpdateHash = true) {
    if (!triggerEl) {
      return;
    }

    const tabReference = triggerEl.dataset.tabReference;
    if (!tabReference) {
      return;
    }

    const containerEl = document.getElementById(tabReference);
    if (!containerEl) {
      return;
    }

    deactivateTriggers(tabReference);
    activateTrigger(triggerEl);
    deactivateAllTabsForContainer(containerEl);
    activateTabInContainer(containerEl, tabNumber);

    if (shouldUpdateHash) {
      const elementHash = triggerEl.dataset.href;
      updateHash(elementHash);
    }

    if (!shouldScroll) {
      return;
    }

    TabsHandler.scrollToTab(containerEl);
  }

  static scrollToTab(containerEl, offset = OFFSET_TOP) {
    const scrollingElement = document.scrollingElement ?
      document.scrollingElement :
      document.documentElement;

    scrollingElement.scrollTop = containerEl.offsetTop - offset;
  }
}

Reedsy.Discovery.TabsHandler = TabsHandler;
